

















































































































import { Component, Watch, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import { InstitutionAccountModule } from '@/store/Accounts/InstitutionAccountModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import { InstitutionsModule } from '@/store/Settings/InstitutionsModule';
import CreatePaymentOrderRequest from '@/models/Accounts/Shared/PaymentOrders/CreatePaymentOrderRequest';
import PaymentOrderSenderDetails from '@/components/Accounts/Shared/PaymentOrders/Steps/PaymentOrderSenderDetails.vue';
import PaymentOrderPayeeDetails from '@/components/Accounts/Shared/PaymentOrders/Steps/PaymentOrderPayeeDetails.vue';
import PaymentOrderPaymentDetails from '@/components/Accounts/Shared/PaymentOrders/Steps/PaymentOrderPaymentDetails.vue';
import PaymentOrderSummary from '@/components/Accounts/Shared/PaymentOrders/Steps/PaymentOrderSummary.vue';
import CreatePayeeType from '@/models/Shared/CreatePayeeType';
import PayeeType from '@/models/Accounts/Shared/Payees/PayeeType';
import Payee from '@/models/Accounts/Shared/Payees/Payee';
import PaymentType from '@/models/Accounts/Shared/Payments/PaymentType';
import Payment from '@/models/Accounts/Shared/Payments/Payment';
import AccountType from '@/models/Shared/AccountType';
import Amount from '@/models/Shared/Amount';
import ScheduleFrequency from '@/models/Shared/ScheduleFrequency';
import Schedule from '@/models/Shared/Schedule';
import Address from '@/models/Customers/Addresses/Address';

@Component({ name: 'PaymentOrderCreate', components: { PaymentOrderSenderDetails, PaymentOrderPayeeDetails, PaymentOrderPaymentDetails, PaymentOrderSummary }  })
export default class extends SaascadaVueDialog {

    currentPage: number = 1;
    amountAsNumber: number = 0;
    payeeType = CreatePayeeType.ExistingPayee;
    paymentType = PaymentType.SinglePayment;
    newPayeeType: PayeeType = null;
    newPayeeAddress: Address = new Address();
    paymentReference: string = '';
    selectedPayee: Payee = new Payee();
    newPayment = new Payment();
    request: CreatePaymentOrderRequest = new CreatePaymentOrderRequest();
    expiresAtDateAsString: string = '';
    minEndDateAsString: string = '';
    todaysDateAsString: string = '';
    tomorrowsDateAsString: string = '';
    valid = false;

    @Prop({required: true})
    isCustomerAccount: boolean;

    @Prop({required: true})
    accountId: string;

    @Prop({required: true})
    currency: string;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            // Reset all of the variables to defaults, then create new payee and payment order request
            this.currentPage = 1;
            this.amountAsNumber = 0;
            this.payeeType = CreatePayeeType.ExistingPayee;
            this.paymentType = PaymentType.SinglePayment;
            this.newPayeeType = undefined;
            this.newPayeeAddress = new Address();
            this.paymentReference = '';
            this.selectedPayee = new Payee();
            this.newPayment = new Payment();
            this.request = new CreatePaymentOrderRequest();

            // Set date as a week in advance by default
            const expiresDate = new Date();
            expiresDate.setDate(expiresDate.getDate() + 7);
            this.expiresAtDateAsString = expiresDate.toISOString().slice(0, 10);

            // Set todays date
            this.todaysDateAsString = new Date().toISOString().split('T')[0];
            // Set tomorrows date
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            this.tomorrowsDateAsString = tomorrow.toISOString().split('T')[0];

            // If the address information of the institution exists, use it to set address defaults
            if (this.institutionAddress) {
                if (this.isCustomerAccount) {
                    // For Customer Accounts the only field that will be useful is the country
                    this.request.customerAddress.country = this.institutionAddress.country;
                }
                else {
                    // For Insitution Accounts all of the address fields can be used
                    this.request.customerAddress.addressLine1 = this.institutionAddress.addressLine1;
                    this.request.customerAddress.addressLine2 = this.institutionAddress.addressLine2;
                    this.request.customerAddress.city = this.institutionAddress.city;
                    this.request.customerAddress.county = this.institutionAddress.county;
                    this.request.customerAddress.postCode = this.institutionAddress.postCode;
                    this.request.customerAddress.country = this.institutionAddress.country;
                }
            }

            // If there is only one scheme available then set it by default
            if (this.schemes.length === 1) {
                this.request.scheme = this.schemes[0];
            }

            // Get the latest payees when the modal opens
            if (this.isCustomerAccount) {
                await DepositAccountModule.getPayeesForDialog();
            }
            else {
                await InstitutionAccountModule.getPayeesForDialog(this.accountId);
            }
        }
    }

    get institutionAddress() {
        return InstitutionsModule.institutionLoggedIn.address;
    }

    get payees() {
        if (this.isCustomerAccount) {
            return DepositAccountModule.payeesForDialog;
        }
        else {
            return InstitutionAccountModule.payeesForDialog;
        }
    }

    get schemes() {
        // TODO: This is currently taken from the go backend hardcoded field for AvailablePaymentSchemes
        // But once this has been added to the main config the function can be swapped for just "institution.availablePaymentSchemes"
        return AuthModule.me.institution.config.availablePaymentSchemes;
    }

    setPayeeType(payeeType: CreatePayeeType) {
        this.payeeType = payeeType;
        // Reset the payee details back to defaults
        this.selectedPayee = new Payee();
        this.newPayeeType = undefined;
        // Reset the form validation
        (this.$refs.formStep2 as any).resetValidation();
    }

    setPaymentType(paymentType: PaymentType) {
        this.paymentType = paymentType;
        // If scheduled payment then initialise the schedule object with the start date initialised as tomorrow
        if (paymentType === PaymentType.ScheduledPayment) {
            this.request.schedule = new Schedule();
            this.request.schedule.startDate = this.tomorrowsDateAsString;
        }
        else {
            this.request.schedule = undefined;
        }
        // Reset the form validation
        (this.$refs.formStep3 as any).resetValidation();
    }

    setNewPayeeName(name: string) {
        this.selectedPayee.name = name;
    }

    setNewPayeeType(newPayeeType: PayeeType) {
        this.newPayeeType = newPayeeType;
    }

    setNewPayeeSortCode(sortCode: string) {
        this.selectedPayee.sortCode = sortCode;
    }

    setNewPayeeAccountNumber(accountNumber: string) {
        this.selectedPayee.accountNumber = accountNumber;
    }

    setNewPayeeIban(iban: string) {
        this.selectedPayee.iban = iban;
    }

    setSelectedPayee(payee: Payee) {
        this.selectedPayee = payee;
    }

    setScheme(scheme: string) {
        this.request.scheme = scheme;
    }

    setPaymentScheduleFrequency(scheduleFrequency: ScheduleFrequency) {
        this.request.schedule.frequency = scheduleFrequency;
    }

    setPaymentScheduleStartDate(scheduleStartDate: string) {
        this.request.schedule.startDate = scheduleStartDate;
        // Setting a new start date will reset the minimum end date
        this.minEndDateAsString = scheduleStartDate;
    }

    setPaymentScheduleEndDate(scheduleEndDate: string) {
        this.request.schedule.endDate = scheduleEndDate;
    }

    setPaymentReference(paymentReference: string) {
        this.paymentReference = paymentReference;
    }

    setAmountAsNumber(amountAsNumber: number) {
        this.amountAsNumber = amountAsNumber;
    }

    setExpiresAtDateAsString(expiresAt: string) {
        this.expiresAtDateAsString = expiresAt;
    }

    async cancel() {
        this.dialog = false;
    }

    async back() {
        this.currentPage = this.currentPage - 1;
    }

    async next() {

        // If the current page is 3 (and we just pressed next) then set the payment and payee information
        if (this.currentPage === 3) {
            // Build the default name for the payment order
            const amountAsCurrency = this.amountAsNumber/100;
            this.request.name = `Send ${amountAsCurrency} ${this.currency} to ${this.selectedPayee.name}`;
            // Reset existing payments array and create a new payment
            this.request.payments = [];
            // Convert the amount into the right type
            const newPaymentAmount = new Amount();
            newPaymentAmount.amount = String(this.amountAsNumber);
            newPaymentAmount.currency = this.currency;
            // Apply Payee values to the request based on the payee type
            if (this.payeeType === CreatePayeeType.ExistingPayee) {
                this.newPayment.payeeId = this.selectedPayee.id;
            }
            else {
                this.newPayment.payee = new Payee();
                this.newPayment.payee.name = this.selectedPayee.name;
                this.newPayment.payee.payeeType = this.newPayeeType;
                this.newPayment.payee.addressLine1 = this.newPayeeAddress.addressLine1;
                this.newPayment.payee.addressLine2 = this.newPayeeAddress.addressLine2;
                this.newPayment.payee.city = this.newPayeeAddress.city;
                this.newPayment.payee.county = this.newPayeeAddress.county;
                this.newPayment.payee.postCode = this.newPayeeAddress.postCode;
                this.newPayment.payee.country = this.newPayeeAddress.country;
                // Add different account information depending on new payee
                // type and clear information from the opposite condition
                if (this.newPayeeType === PayeeType.UK) {
                    this.newPayment.payee.accountNumber = this.selectedPayee.accountNumber;
                    this.newPayment.payee.sortCode = this.selectedPayee.sortCode;
                    this.newPayment.payee.iban = undefined;
                }
                else {
                    this.newPayment.payee.iban = this.selectedPayee.iban;
                    this.newPayment.payee.accountNumber = undefined;
                    this.newPayment.payee.sortCode = undefined;
                }
            }
            // Apply basic Payment values to the request
            this.newPayment.amount = newPaymentAmount;
            this.newPayment.reference = this.paymentReference;
            // Add new payment to payments array
            this.request.payments.push(this.newPayment);
        }

        // Validate on each step when clicking next, except the last step which is validated on create
        if (this.currentPage === 1 && !(this.$refs.formStep1 as any).validate()) {
            return;
        }
        else if (this.currentPage === 2 && !(this.$refs.formStep2 as any).validate()) {
            return;
        }
        else if (this.currentPage === 3 && !(this.$refs.formStep3 as any).validate()) {
            return;
        }
        else {
            this.currentPage = this.currentPage + 1;
        }
    }

    async create() {
        if (!(this.$refs.formStep4 as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            // Apply values from the final step to the create request
            this.request.accountId = this.accountId;
            this.request.accountType = this.isCustomerAccount ? AccountType.Customer : AccountType.Institution;
            this.request.expiresAtUtc = new Date(this.expiresAtDateAsString);

            // For scheduled payments, remove time from payment schedule dates as the API requires date only not date time
            if (this.paymentType === PaymentType.ScheduledPayment) {
                this.request.schedule.startDate = this.request.schedule.startDate ? this.request.schedule.startDate : undefined;
                this.request.schedule.endDate = this.request.schedule.endDate ? this.request.schedule.endDate : undefined;
            }

            if (this.isCustomerAccount) {
                await DepositAccountModule.createPaymentOrder(this.request);
                await DepositAccountModule.getPaymentOrders(1);
            }
            else {
                await InstitutionAccountModule.createPaymentOrder(this.request);
                await InstitutionAccountModule.getPaymentOrders({ id: this.accountId, pageNumber: 1 });
            }
        }
    }

}
